export enum Source {
    TRANSFER_TO_PAPER = "TTP",
    ATAM = "ATM",
    Dispatch = "Dispatch"
}